<template>
    <div class="filter-bar">
        <div class="footer-bar__inner">
            <slider
                class="filter__bar-slider"
                :slides="filters"
                :autoHeight="true"
                perView="auto"
                :loop="false"
                slideToClicked
            >
                <template #default="{slide}">
                    <button
                        type="button"
                        :class="{'is-active': slide.value === activeValue}"
                        @click="ev => setActiveFilter(ev, slide.value)"
                    >
                        <slot :filter="slide"/>
                    </button>
                </template>
            </slider>
        </div>
    </div>
</template>

<script>

import Slider from '@/components/slider/slider';

export default {
    name: 'FilterBar',

    components: {
        Slider,
    },

    props: {
        filters: {
            type: Array,
            default: () => ([])
        },

        activeValue: {
            type: String,
            default: ''
        }
    },

    setup(_,{ emit }) {
        const setActiveFilter = (event, val) => {
            emit('filter-change', val);
        }

        return {
            setActiveFilter
        }
    }
}
</script>
